import DrupalContext from 'contexts/DrupalContext'
import { transformTitleToId } from 'helpers/string'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

function Header({ children, className }) {
  const { t } = useTranslation()
  const drupal = useContext(DrupalContext)
  const title = t(`title.${drupal.niche || 'global'}`)
  return (
    <div
      id={transformTitleToId(title)}
      className={`layout layout--gray layout--padding-top ${className ? `${className}` : ''}`}
    >
      <div
        className="layout__container layout__container--dynamic"
        style={{ height: 'inherit' }}
      >
        <div className="row layout__inner">
          <div className="columns small-12">
            <h1
              className="heading-condensed heading--small u-mb-100 u-mb-175-large-up"
              id="h1id"
            >
              {title}
            </h1>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
